
import { useState } from 'react';
import { apiClient } from '@/shared/services/api';

interface SendEmailParams {
  to: string;
  subject: string;
  html: string;
  from?: string;
}

export const useEmail = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const sendEmail = async ({ to, subject, html, from }: SendEmailParams) => {
    setIsLoading(true);
    setError(null);

    try {
      // SECURITY: Use backend proxy instead of calling edge function directly
      const data = await apiClient.post('/edge/send-email', {
        to,
        subject,
        html,
        from,
      });

      return data;
    } catch (err: any) {
      setError(err.message);
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    sendEmail,
    isLoading,
    error,
  };
};
